import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { GetCurrentRaidOutput, RaidRoutes } from "types/web-app";

export const getCurrentRaid = async (
  token: string
): Promise<ServiceResponse<GetCurrentRaidOutput>> => {
  const response = await fetchWithAuth(
    `/${RaidRoutes.GET_CURRENT_RAID}`,
    token,
    {
      method: "GET",
    }
  );

  return response.json();
};

